import { h } from "preact";
import { RoutableProps } from "preact-router";
import { resolvePath } from "../../../api";
import { addProductToDatabase } from "../../../api/product-api";
import { manufacturingConfigurations } from "../../../App";
import { AccessoriesPrinting, SerialNumberData } from "../../../components/AccesoriesPrinting";
import "./styles.scss";

export function StellaBIOSerialNumber(props: RoutableProps) {
    return <div class="stella-bio-serial-number-page">
        <AccessoriesPrinting manufacturingConfigurations={manufacturingConfigurations["StellaBIO"] ?? []} serialType="serial-8-base32" generateSerialNumber={(type) => addProductToDatabase(type)}/>
    </div>
}
